import { isValid, parseISO } from 'date-fns';

export const parseDateTime = (inputString: string): Date => parseISO(inputString);

export const isParseableAsDateTime = (inputString: string): boolean => {
  if (!inputString.includes('T')) {
    return false;
  }

  return isValid(parseISO(inputString));
};
